import gql from 'graphql-tag';

export const FETCH_IMAGE_SLIDERS = gql`
  query {
    getImageSliders {
      id
      url
    }
  }
`;

export const ALL_PAYMENTS_DONE = gql`
  query {
    getAllUnpaidBooks {
      id
      amount
      payment_type
      createdAt
      buyerInfo {
        firstname
        lastname
        username
        profile
      }
      sellerInfo {
        firstname
        lastname
        username
        profile
      }
      paidBookInfo {
        name
        slug
        coverUrl
        MoMoNumber
        paypalEmail
        AirtelMoneyNumber
      }
      paymentToken
    }
  }
`;

export const FETCH_ALL_USERS = gql`
  {
    getUsers {
      id
      firstname
      lastname
      username
      telephone
      address
      email
      profile
      verified
      role
      books {
        id
        name
        slug
      }
      createdAt
      deletedAt
    }
  }
`;

export const FETCH_ALL_BOOKS = gql`
  {
    getAllBooks {
      id
      name
      slug
      coverUrl
      audioUrl
      videoUrl
      bookUrl
      price
      userId
      category
      tags {
        tagName
      }
      author
      summary
      publishedCompany
      status
      bookCount
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FDI_GET_CURRENT_BALANCE = gql`
  query {
    fdiGetCurrentBalance {
      date
      accounts {
        currency
        balanceActual
        balanceAvailable
      }
    }
  }
`;

export const ALL_PAYMENTS_SUCCEED = gql`
  query {
    getAllPaymentSucceed {
      id
      amount
      user_id
      payment_type
      createdAt
      buyerInfo {
        firstname
        lastname
        username
        profile
      }
      sellerInfo {
        firstname
        lastname
        username
        profile
      }
      paidBookInfo {
        name
        coverUrl
        MoMoNumber
        paypalEmail
        AirtelMoneyNumber
      }
    }
  }
`;

export const ALL_PAYMENTS_UNCLAIMED = gql`
  query {
    getAllPaymentUnclaimed {
      id
      amount
      user_id
      payment_type
      createdAt
      buyerInfo {
        firstname
        lastname
        username
        profile
      }
      sellerInfo {
        firstname
        lastname
        username
        profile
      }
      paidBookInfo {
        name
        coverUrl
        MoMoNumber
        paypalEmail
        AirtelMoneyNumber
      }
    }
  }
`;

export const FETCH_ALL_REPORTED_BOOKS = gql`
  {
    getAllReports {
      id
      description
      createdAt
      user {
        id
        username
        email
        lastname
        firstname
        role
      }
      book {
        id
        name
        slug
        status
        audioUrl
        coverUrl
        videoUrl
        author
        summary
        publishedCompany
      }
    }
  }
`;

export const FETCH_ALL_CONTACTED_US = gql`
  {
    getAllContactUs {
      id
      fullname
      telephone
      email
      subject
      body
      createdAt
    }
  }
`;
export const FETCH_ALL_MY_NOTIFICATIONS = gql`
  {
    getAllMyNotifications {
      id
      notificationBody
      sendFrom
      sendTo
      isOpenned
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FETCH_ALL_NOTIFICATIONS = gql`
  {
    getAllNotifications {
      id
      notificationBody
      sendFrom
      sendTo
      isOpenned
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const FETCH_ALL_MY_BOOKS = gql`
  {
    getAllBooksOfAuthor {
      id
      name
      slug
      coverUrl
      audioUrl
      videoUrl
      bookUrl
      price
      userId
      category
      tags {
        tagName
      }
      author
      summary
      publishedCompany
      status
      createdAt
      updatedAt
    }
  }
`;

export const FETCH_ALL_APPLOVED_BOOKS = gql`
  query getAllApprovedBooks($limit: Int, $cursor: String, $action: String!) {
    getAllApprovedBooks(limit: $limit, cursor: $cursor, action: $action) {
      edges {
        id
        name
        slug
        coverUrl
        hasAudioUrl
        hasVideoUrl
        hasBookUrl
        userId
        price
        category
        tags {
          tagName
        }
        author
        summary
        publishedCompany
        status
        createdAt
        updatedAt
        createdBy {
          id
          username
          email
        }
      }
      pageInfo {
        hasPreviousPage
        previousCursor
        hasNextPage
        endCursor
      }
    }
  }
`;

export const FETCH_ONE_BOOK = gql`
  query getOneBook($slug: String!) {
    getOneBook(slug: $slug) {
      id
      name
      userId
      slug
      coverUrl
      audioUrl
      videoUrl
      bookUrl
      hasAudioUrl
      hasVideoUrl
      hasBookUrl
      price
      category
      bookCount
      tags {
        tagName
      }
      author
      summary
      publishedCompany
      status
      createdAt
      updatedAt
      createdBy {
        id
        username
        email
        profile
      }
      books {
        id
        name
        slug
        coverUrl
        price
        createdAt
        updatedAt
      }
    }
  }
`;

export const FETCH_ALL_BOOKS_IN_MY_CART = gql`
  query {
    allBooksInMyCart {
      carts {
        id
        user {
          id
          username
          email
        }
        book {
          id
          name
          userId
          author
          slug
          coverUrl
          hasAudioUrl
          hasBookUrl
          hasVideoUrl
          price
          summary
          publishedCompany
        }
      }
      totalAmount
    }
  }
`;

export const FETCH_ALL_BOOK_REVIEWS = gql`
  query getBookReviews($slug: String!) {
    getBookReviews(slug: $slug) {
      id
      review
      ratingValue
      slug
      userId
      bookId
      createdAt
      updatedAt
      user {
        id
        username
        profile
      }
      book {
        id
        name
        slug
      }
    }
  }
`;

export const FETCH_AVERAGE_RATE = gql`
  query ratingAverage($slug: String!) {
    ratingAverage(slug: $slug) {
      average
    }
  }
`;

export const FETCH_ALL_BESTSELLERS_BOOKS = gql`
  {
    getAllBooksOfBestSellers {
      id
      amount
      user_id
      payment_type
      buyerInfo {
        firstname
        lastname
        username
        profile
      }
      sellerInfo {
        id
        firstname
        lastname
        username
        profile
      }
      paidBookInfo {
        id
        name
        coverUrl
        hasBookUrl
        hasAudioUrl
        hasVideoUrl
        author
        price
        slug
        publishedCompany
      }
    }
  }
`;

export const FETCH_ALL_MADE_INTO_ANIMATION = gql`
  query {
    getAllMadeIntoAnimationBooks {
      id
      name
      slug
      coverUrl
      hasAudioUrl
      hasVideoUrl
      hasBookUrl
      price
      userId
      category
      tags {
        tagName
      }
      author
      summary
      publishedCompany
      status
      createdAt
      updatedAt
      createdBy {
        id
        username
        email
      }
    }
  }
`;

export const GET_USER_PROFILE = gql`
  query getOneUserProfile($username: String!) {
    getOneUserProfile(username: $username) {
      id
      email
      profile
      telephone
      firstname
      lastname
      username
      address
      verified
      role
      books {
        name
        price
        slug
        publishedCompany
        author
        coverUrl
        audioUrl
        videoUrl
        bookUrl
        hasAudioUrl
        hasBookUrl
        hasVideoUrl
        userId
        tags {
          tagName
        }
      }
    }
  }
`;

export const SEARCH_BOOK = gql`
  query search($keyword: String!) {
    search(keyword: $keyword) {
      id
      name
      userId
      slug
      coverUrl
      audioUrl
      price
      category
      tags {
        tagName
      }
      author
      summary
      publishedCompany
      status
      createdAt
      updatedAt
    }
  }
`;

export const FETCH_ALL_PAID_BOOKS = gql`
  query getAllPaidBookByUser($userId: Int!) {
    getAllPaidBookByUser(userId: $userId) {
      id
      name
      slug
      audioUrl
      coverUrl
      videoUrl
      bookUrl
      hasVideoUrl
      hasAudioUrl
      hasBookUrl
    }
  }
`;
